import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const GET_APPOINTMENT_EXPORT_LIST = 'GET_APPOINTMENT_EXPORT_LIST';
export const GET_APPOINTMENT_EXPORT_LIST_SUCCESS =
  'GET_APPOINTMENT_EXPORT_LIST_SUCCESS';
export const GET_APPOINTMENT_EXPORT_LIST_FAILURE =
  'GET_APPOINTMENT_EXPORT_LIST_FAILURE';

// Action Creators
export const fetchGetAppointmentExport = () => ({
  type: GET_APPOINTMENT_EXPORT_LIST,
});

export const fetchGetAppointmentExportSuccess = (data) => ({
  type: GET_APPOINTMENT_EXPORT_LIST_SUCCESS,
  payload: data,
});

export const fetchGetAppointmentExportFailure = (error) => ({
  type: GET_APPOINTMENT_EXPORT_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getAppointmentExportCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetAppointmentExport(data, external));
    try {
      const response = await getMethodWithToken(
        url.getAppointmentDataSuperAdmin + '?type=download'
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetAppointmentExportSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetAppointmentExportFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetAppointmentExportFailure(error.message));
    }
  };
};
